module.exports = __webpack_public_path__ + "img/certificate.73b3e12f.png";